import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";

import AthHairTypeBar from '../../components/profile/AthHairTypeBar';
import SelectButton from '../../../components/icon/SelectButton';
import LoadingBlock from '../../../components/common/LoadingBlock';
import * as util from '../../../utils/util';
import * as aaUtil from '../../utils/aaUtils';

import './AthHairProfile.css';

const hairGoalsInds = [
  "Hydration",
  "Curl definition",
  "Volume",
  "Strengthen",
  "Smooth",
  "Color",
  "Protection",
  "Shine",
  "Frizz free",
  "Dandruff control",
  "Hair loss control"
];

const textureInds = [
  "Fine",
  "Normal",
  "Thick"
];

const shapeInds = [
  "Straight",
  "Wavy",
  "Curly",
  "Tight Curls",
  "Coily"
];

class AthHairProfile extends Component {
    constructor(props){
        super(props);

        this.state = {
            loadingDone: false,
            width: document.documentElement.clientWidth,
            selectedHairGoals: [],
            isEditingHairGoals: false,
        };

        this.products = [];
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this));
        this.setState({ loadingDone: true });
        window.zE("webWidget", {chat: {
          supress: false
        }}, "show");
    }

    componentWillMount() {
        const userId = localStorage.getItem("ath_user_id");
        if (userId) {
            this.fetchResult();
        } else {
          this.props.history.push('/ath/login');
        }
            // if (this.state.productsForReview) {
            //     this.fetchResult();
            // }
            // const showRecommendationFlag = userId + ":enable_recommendations";
            // const visitedRecommendations = localStorage.getItem(showRecommendationFlag);
            // if (visitedRecommendations) {
            //     this.setState({visitedRecommendations: true});
            // } else {
            //     fetch('/api/user-flags/show-recommendation?user-id=' + userId, {
            //         method: 'GET',
            //         headers: {
            //             'x-auth-token': localStorage.getItem("ath_auth_token")
            //         }
            //     }).then(response => response.text()).then(status => {
            //         if (status === 'true') {
            //             this.setState({visitedRecommendations: true});
            //             localStorage.setItem(showRecommendationFlag, 'enabled');
            //         }
            //     });
            // }
    }

    componentWillUnmount() {
      window.zE("webWidget", "hide");
    }

    handleMediaQueries() {

        this.setState({
            width: document.documentElement.clientWidth
        });
    }

    fetchResult() {
        const userId = localStorage.getItem("ath_user_id");
        fetch('/api/ath-hair-profiles?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem("ath_auth_token")
            }
        }).then((response) => response.json()).then(responseJson => {
            responseJson.forEach(item => {
                this.setState({
                  [util.camelize(item.type)]: item,
                  selectedHairGoals: responseJson.find(cat => cat.type === "Concern").selections.split(",").map(ind => parseInt(ind, 10))
                });
            });
            this.setState({ loadingDone: true });
        }).catch(function(err) {
            alert("There was a problem getting your survey results. Please try again.");
        });
    }

    selectPasIcon = (id) => {
      const splits = id.split("-");
      const type = splits[0];
      let index = splits[1];
        let selectedHairGoals = this.state.selectedHairGoals;
        selectedHairGoals.push(parseInt(index,10));
        this.setState({ selectedHairGoals: selectedHairGoals });

    }

    deselectPasIcon = (id) => {
      const splits = id.split("-");
      const type = splits[0];
      let index = splits[1];
      if (type === 'hairgoal') {
        let selectedHairGoals = this.state.selectedHairGoals;
        index = parseInt(index, 10);
        selectedHairGoals.splice(selectedHairGoals.indexOf(index), 1);
        // if(this.state.selectedHairGoals.indexOf(index) === -1) selectedHairGoals.splice(selectedHairGoals.indexOf(index), 1);
        this.setState({ selectedHairGoals: selectedHairGoals });
      }
    }

    saveHairGoals = () => {
      const userId = localStorage.getItem("ath_user_id");
      aaUtil.event2_click_event('Saved Hair Goals');
      fetch('/api/ath-hair-profiles', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem("ath_auth_token")
        },
        body: JSON.stringify({
          "userId": userId,
          "Concern": this.state.selectedHairGoals.join()
        })
      })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          this.setState({ isEditingHairGoals: false });
          this.fetchResult();
        }
      });
    }

    toggleSummary() {
        this.setState({
            descriptionExpanded: !this.state.descriptionExpanded
        });


    }

    toggleStrength() {
        this.setState({
            strengthExpanded: !this.state.strengthExpanded
        });
    }

    toggleWeakness() {
        this.setState({
            weaknessExpanded: !this.state.weaknessExpanded
        });
    }

    toggleRecommendations() {
        const showRecommendations = this.state.showRecommendations;
        let recommendationButtonText = showRecommendations ? "View My Recommendations" : "Hide My Recommendations";

        this.setState({
            showRecommendations: !this.state.showRecommendations,
            recommendationButtonText: recommendationButtonText
        });
    }

    directToLandingPage() {
        // const phoneNumber = localStorage.getItem('phone_number');
        // if (phoneNumber) {
        //     const phoneNumberLength = phoneNumber.length;
        //     return phoneNumber[phoneNumberLength - 1] > 4;
        // }

        // if (util.isMobile(navigator.userAgent)) {
        //     return true;
        // }

        return true;
    }

    toggleShareCard(callback) {
        this.setState({
            showDummyDiv: true
        }, function() {
            if (this.state.showDummyDiv) callback();
        });
    }

    hideDummyDiv() {
        this.setState({ showDummyDiv: false });
    }

    render() {
        const isEditingHairGoals = this.state.isEditingHairGoals;

        const selectedHairGoals = this.state.selectedHairGoals.map(index => {
          index = parseInt(index, 10);
            return (
                <div key={ index } className="option">
                    <SelectButton name={ hairGoalsInds[index - 1] } selectable={ isEditingHairGoals }
                        selected={ true } id={ "hairgoal-" + index }
                        onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        // let selectedSkinConcernMap = Object.assign({}, indexMap);
        const allHairGoalOptions = hairGoalsInds.map((goal, ind) => {
          let index = ind + 1;
            return (
                <div key={ ind } className="option">
                    <SelectButton name={ goal } selectable={ isEditingHairGoals }
                        selected={  this.state.selectedHairGoals.indexOf(parseInt(index, 10)) > -1 } id={ "hairgoal-" + index }
                        onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        const userFirstName = localStorage.getItem('ath_user_firstname');
        const userId = localStorage.getItem('ath_user_id');

        return (


            <div id="survey-result" className="ath-onboarding">
                <Helmet>
                    <title>Hair Profile - HelloAva</title>
                    <meta name="description" content="Here are the results of your skin care questionaire!" />
                </Helmet>


                {
                    this.state.loadingDone ?
                    <div className="loading-done-survey-result">
                        <div id="survey-result-body" className="survey-result-body">
                          <div className="ath-hair-profile">
                            <div className="ath-hair-profile__header">
                              <h2>Hi { userFirstName }, here’s your hair consultation result.</h2>
                            </div>
                            <div className="ath-hair-profile__section ath-hair-profile__section__hair-type">
                              <div className="ath-hair-profile__hair-type-blocks">
                                <div className="ath-hair-profile__hair-type-block ath_hair-profile__hair-type-block__left">
                                  <h4 className="ath-hair-profile__hair-type-block-header">Texture</h4>
                                    {
                                      this.state.texture ?
                                      <img alt="texture" src={ "/images/ath/profile/" + textureInds[parseInt(this.state.texture.selections, 10) - 1].toLowerCase() + ".png"  } /> :
                                      <div className="ath-hair-profile__hair-type-icon">
                                      </div>
                                    }
                                  <h5 className="ath-hair-profile__hair-type-block-type">{ this.state.texture ? textureInds[parseInt(this.state.texture.selections, 10) - 1]  : "Determining texture..." }</h5>
                                </div>
                                <div className="ath-hair-profile__hair-type-block ath-hair-profile__hair-type-block__right">
                                  <h4 className="ath-hair-profile__hair-type-block-header">Shape</h4>
                                    {
                                      this.state.shape ?
                                      <img alt="shape" src={ "/images/ath/profile/" +  shapeInds[parseInt(this.state.shape.selections, 10) - 1].toLowerCase() + ".png"  } /> :
                                      <div className="ath-hair-profile__hair-type-icon">
                                      </div>
                                    }
                                  <h5 className="ath-hair-profile__hair-type-block-type">{ this.state.shape ? shapeInds[parseInt(this.state.shape.selections, 10) - 1]  : "Determining shape..." }</h5>
                                </div>
                              </div>
                              <div className="ath-hair-profile__hair-type-bars">
                                <AthHairTypeBar
                                  category="condition"
                                  leftLabel="dry"
                                  rightLabel="moist"
                                  score={ this.state.condition1 && this.state.condition2 ? parseInt(this.state.condition1.selections, 10) + parseInt(this.state.condition2.selections, 10) : 0 }
                                  userId={ userId }
                                />
                                <AthHairTypeBar
                                  category="dandruff"
                                  leftLabel="never"
                                  rightLabel="always"
                                  score={ this.state.dandruff ? parseInt(this.state.dandruff.selections, 10) : 0 }
                                  userId={ userId }
                                />
                                <AthHairTypeBar
                                  category="volume"
                                  leftLabel="flat"
                                  rightLabel="thick"
                                  score={ this.state.volume ? parseInt(this.state.volume.selections, 10) : 0 }
                                  userId={ userId }
                                />
                              </div>
                            </div>
                            <div className="ath-hair-profile__section ath-hair-profile__section__hair-goals">
                              <div className="ath-hair-profile__hair-goals-header">
                                <div className="ath-hair-profile__hair-goals-header-row row">
                                    <h4>Hair Goals</h4>
                                    <img alt="Edit" src="/images/common/edit.svg" onClick={() => {
                                      aaUtil.event2_click_event('Editing Hair Goals');
                                      this.setState({ isEditingHairGoals: !this.state.isEditingHairGoals });
                                    }} />
                                </div>
                                <div className="ath-hair-profile__hair-goals-container pas">
                                  <div className="options">{ !isEditingHairGoals && selectedHairGoals }{isEditingHairGoals && allHairGoalOptions }{isEditingHairGoals && <div className="options-button"><button onClick={ this.saveHairGoals }>Save</button></div>}</div>
                                </div>
                              </div>
                              <div id="recommendation-button-section">
                                  <a onClick={ () =>
                                    aaUtil.event2_click_event('Navigate to Recommendations (View Recommendations button)') } href="/ath/recommendations"><button>View My Recommendations</button></a>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div> :
                    <LoadingBlock />

                }

            </div>

        );
    }
}

export default withRouter(AthHairProfile);



// WEBPACK FOOTER //
// ./src/ath/views/profile/AthHairProfile.js